
import { _createInstance } from '../base';
//实例
let instance = null;
const createToogle = async function (config) {
    console.log(_createInstance)
  try {
    if (!instance) {
      instance = await _createInstance(`/toogle/template`,this.$store);
    }
    console.log(instance)
    instance.showPanel(config);
  } catch (error) {
  }



}

export default createToogle;


// WEBPACK FOOTER //
// src/components/dialog/toogle/index.js